export const LOAD_ECCENTRICITY_MISSING_MESSAGE = 'Bitte einen Wert angeben (0 für zentrisch).'

export type LoadEccentricityAxis = keyof LoadEccentricity

const isFiniteNumber = (value: unknown): boolean =>
  typeof value === 'number' && Number.isFinite(value)

/**
 * The eccentricities that are not a number (e.g. an emptied field), in the
 * order of the form. Empty when the settings have no load eccentricity.
 */
export const getMissingLoadEccentricityAxes = (
  settings: SettingsOnMember | null | undefined,
): LoadEccentricityAxis[] => {
  if (!settings || !('load_eccentricity' in settings) || !settings.load_eccentricity) return []
  const eccentricity = settings.load_eccentricity
  return (['e_y', 'e_z'] as const).filter(axis => !isFiniteNumber(eccentricity[axis]))
}

export const isLoadEccentricityComplete = (
  settings: SettingsOnMember | null | undefined,
): boolean => getMissingLoadEccentricityAxes(settings).length === 0
